/**
 * Do not edit directly
 * Generated on Fri, 21 Jun 2024 06:24:43 GMT
 */ const dtcgTokensRaw = {
    "SwanBaseBorderRadius0": "0px",
    "SwanBaseBorderRadius100": "4px",
    "SwanBaseBorderRadius200": "8px",
    "SwanBaseBorderRadius300": "12px",
    "SwanBaseBorderRadius400": "16px",
    "SwanBaseBorderRadiusMax": "9999px",
    "SwanBaseBorderWidth0": "0px",
    "SwanBaseBorderWidth100": "1px",
    "SwanBaseBorderWidth200": "2px",
    "SwanBaseBorderWidth300": "3px",
    "SwanBaseBreakpointXsStart": "0px",
    "SwanBaseBreakpointXsEnd": "767px",
    "SwanBaseBreakpointSmStart": "768px",
    "SwanBaseBreakpointSmEnd": "1023px",
    "SwanBaseBreakpointMdStart": "1024px",
    "SwanBaseBreakpointMdEnd": "1439px",
    "SwanBaseBreakpointLgStart": "1440px",
    "SwanBaseBreakpointLgEnd": "1919px",
    "SwanBaseBreakpointXlStart": "1920px",
    "SwanBaseColorTransparent": "transparent",
    "SwanBaseColorBlack": "#000000",
    "SwanBaseColorBlackOpacity90": "rgba(0,0,0,0.9)",
    "SwanBaseColorBlackOpacity80": "rgba(0,0,0,0.8)",
    "SwanBaseColorBlackOpacity70": "rgba(0,0,0,0.7)",
    "SwanBaseColorBlackOpacity60": "rgba(0,0,0,0.6)",
    "SwanBaseColorBlackOpacity50": "rgba(0,0,0,0.5)",
    "SwanBaseColorBlackOpacity40": "rgba(0,0,0,0.4)",
    "SwanBaseColorBlackOpacity30": "rgba(0,0,0,0.3)",
    "SwanBaseColorBlackOpacity20": "rgba(0,0,0,0.2)",
    "SwanBaseColorBlackOpacity10": "rgba(0,0,0,0.1)",
    "SwanBaseColorGrey100": "#f8f8f8",
    "SwanBaseColorGrey200": "#efefef",
    "SwanBaseColorGrey300": "#dfdfdf",
    "SwanBaseColorGrey400": "#c4c4c4",
    "SwanBaseColorGrey500": "#9e9e9e",
    "SwanBaseColorGrey600": "#707070",
    "SwanBaseColorGrey700": "#5c5c5c",
    "SwanBaseColorGrey800": "#313131",
    "SwanBaseColorGrey900": "#151515",
    "SwanBaseColorWhite": "#ffffff",
    "SwanBaseColorWhiteOpacity90": "rgba(255,255,255,0.9)",
    "SwanBaseColorWhiteOpacity80": "rgba(255,255,255,0.8)",
    "SwanBaseColorWhiteOpacity70": "rgba(255,255,255,0.7)",
    "SwanBaseColorWhiteOpacity60": "rgba(255,255,255,0.6)",
    "SwanBaseColorWhiteOpacity50": "rgba(255,255,255,0.5)",
    "SwanBaseColorWhiteOpacity40": "rgba(255,255,255,0.4)",
    "SwanBaseColorWhiteOpacity30": "rgba(255,255,255,0.3)",
    "SwanBaseColorWhiteOpacity20": "rgba(255,255,255,0.2)",
    "SwanBaseColorWhiteOpacity10": "rgba(255,255,255,0.1)",
    "SwanBaseColorRed100": "#fff0f0",
    "SwanBaseColorRed400": "#f27373",
    "SwanBaseColorRed700": "#d24345",
    "SwanBaseColorYellow100": "#faf1d7",
    "SwanBaseColorYellow700": "#e8b738",
    "SwanBaseColorYellow900": "#ba5d1a",
    "SwanBaseColorGreen100": "#e7f3f0",
    "SwanBaseColorGreen400": "#60D799",
    "SwanBaseColorGreen700": "#318643",
    "SwanBaseColorBlue400": "#99d3f3",
    "SwanBaseColorBlue700": "#017eb4",
    "SwanBaseFontFamilyPrimary": "Graphik, sans-serif",
    "SwanBaseFontFamilySecondary": "Tiempos, Georgia, times, serif",
    "SwanBaseFontSize100": "16px",
    "SwanBaseFontSize200": "18px",
    "SwanBaseFontSize300": "20px",
    "SwanBaseFontSize400": "24px",
    "SwanBaseFontSize500": "28px",
    "SwanBaseFontSize600": "32px",
    "SwanBaseFontSize700": "36px",
    "SwanBaseFontSize800": "42px",
    "SwanBaseFontSize900": "57px",
    "SwanBaseFontSize050": "12px",
    "SwanBaseFontSize075": "14px",
    "SwanBaseFontWeightNormal": "400",
    "SwanBaseFontWeightBold": "700",
    "SwanBaseFontLetterSpacing100": "0.005em",
    "SwanBaseFontLetterSpacing200": "0.005em",
    "SwanBaseFontLetterSpacing300": "0.005em",
    "SwanBaseFontLetterSpacing025": "-0.01em",
    "SwanBaseFontLetterSpacing050": "-0.01em",
    "SwanBaseFontLetterSpacing075": "-0.01em",
    "SwanBaseFontLineHeight100": 1.1,
    "SwanBaseFontLineHeight200": 1.2,
    "SwanBaseFontLineHeight300": 1.2,
    "SwanBaseFontLineHeight400": 1.2,
    "SwanBaseFontLineHeight500": 1.5,
    "SwanBaseFontLineHeight075": 0.9,
    "SwanBaseSpace0": "0px",
    "SwanBaseSpace100": "8px",
    "SwanBaseSpace150": "12px",
    "SwanBaseSpace200": "16px",
    "SwanBaseSpace300": "24px",
    "SwanBaseSpace400": "32px",
    "SwanBaseSpace550": "44px",
    "SwanBaseSpace700": "56px",
    "SwanBaseSpace900": "72px",
    "SwanBaseSpace1200": "96px",
    "SwanBaseSpace1600": "128px",
    "SwanBaseSpace025": "2px",
    "SwanBaseSpace050": "4px",
    "SwanBaseSpace075": "6px",
    "SwanSemBorderRadiusNone": "0px",
    "SwanSemBorderRadiusSubtle": "4px",
    "SwanSemBorderRadiusStandard": "8px",
    "SwanSemBorderRadiusStrong": "16px",
    "SwanSemBorderRadiusRounded": "9999px",
    "SwanSemBorderRadiusFocus": "4px",
    "SwanSemBorderRadiusAction": "9999px",
    "SwanSemBorderRadiusInput": "8px",
    "SwanSemBorderRadiusContainer": "8px",
    "SwanSemBorderWidthNone": "0px",
    "SwanSemBorderWidthStandard": "1px",
    "SwanSemBorderWidthStrong": "2px",
    "SwanSemBorderWidthStronger": "3px",
    "SwanSemBorderWidthInput": "1px",
    "SwanSemBorderWidthAction": "1px",
    "SwanSemBorderWidthPartition": "1px",
    "SwanSemBorderWidthFloating": "1px",
    "SwanSemColorBgNone": "transparent",
    "SwanSemColorBgNoneHover": "rgba(0,0,0,0.2)",
    "SwanSemColorBgNoneActive": "rgba(0,0,0,0.4)",
    "SwanSemColorBgStandard": "#ffffff",
    "SwanSemColorBgHover": "#efefef",
    "SwanSemColorBgActive": "#dfdfdf",
    "SwanSemColorBgStrong": "#f8f8f8",
    "SwanSemColorBgStrongHover": "#efefef",
    "SwanSemColorBgStrongActive": "#dfdfdf",
    "SwanSemColorBgDisabled": "#dfdfdf",
    "SwanSemColorBgSelected": "#000000",
    "SwanSemColorBgSelectedHover": "#313131",
    "SwanSemColorBgSelectedActive": "#5c5c5c",
    "SwanSemColorBgAccent": "#99d3f3",
    "SwanSemColorBgError": "#d24345",
    "SwanSemColorBgWarning": "#e8b738",
    "SwanSemColorBgSuccess": "#318643",
    "SwanSemColorBgPromo": "#e7f3f0",
    "SwanSemColorBgHelp": "#3E3CBC",
    "SwanSemColorBgAction": "#ffffff",
    "SwanSemColorBgActionHover": "#efefef",
    "SwanSemColorBgActionActive": "#dfdfdf",
    "SwanSemColorBgControl": "#ffffff",
    "SwanSemColorBgControlHover": "#efefef",
    "SwanSemColorBgControlActive": "#dfdfdf",
    "SwanSemColorBgInput": "#ffffff",
    "SwanSemColorBgContainer": "#ffffff",
    "SwanSemColorBgPage": "#ffffff",
    "SwanSemColorBorderNone": "transparent",
    "SwanSemColorBorderNoneHover": "rgba(0,0,0,0.2)",
    "SwanSemColorBorderNoneActive": "rgba(0,0,0,0.4)",
    "SwanSemColorBorderStandard": "#dfdfdf",
    "SwanSemColorBorderHover": "#9e9e9e",
    "SwanSemColorBorderActive": "#707070",
    "SwanSemColorBorderStrong": "#707070",
    "SwanSemColorBorderStrongHover": "#313131",
    "SwanSemColorBorderStrongActive": "#151515",
    "SwanSemColorBorderDisabled": "#dfdfdf",
    "SwanSemColorBorderSelected": "#000000",
    "SwanSemColorBorderSelectedHover": "#313131",
    "SwanSemColorBorderSelectedActive": "#5c5c5c",
    "SwanSemColorBorderAccent": "#017eb4",
    "SwanSemColorBorderError": "#d24345",
    "SwanSemColorBorderWarning": "#e8b738",
    "SwanSemColorBorderSuccess": "#318643",
    "SwanSemColorBorderPromo": "#318643",
    "SwanSemColorBorderHelp": "#3e3cbc",
    "SwanSemColorBorderAction": "#dfdfdf",
    "SwanSemColorBorderActionHover": "#9e9e9e",
    "SwanSemColorBorderActionActive": "#707070",
    "SwanSemColorBorderControl": "#707070",
    "SwanSemColorBorderControlHover": "#313131",
    "SwanSemColorBorderControlActive": "#151515",
    "SwanSemColorBorderInput": "#707070",
    "SwanSemColorBorderInputHover": "#313131",
    "SwanSemColorBorderInputActive": "#151515",
    "SwanSemColorBorderContainer": "#dfdfdf",
    "SwanSemColorBorderPartition": "#dfdfdf",
    "SwanSemColorTextStandard": "rgba(0,0,0,0.9)",
    "SwanSemColorTextSubtle": "#5c5c5c",
    "SwanSemColorTextInput": "rgba(0,0,0,0.9)",
    "SwanSemColorTextPlaceholder": "#5c5c5c",
    "SwanSemColorTextError": "#d24345",
    "SwanSemColorTextWarning": "#ba5d1a",
    "SwanSemColorTextDisabled": "#9e9e9e",
    "SwanSemColorTextPromo": "#318643",
    "SwanSemColorTextHover": "rgba(0,0,0,0.7)",
    "SwanSemColorTextActive": "rgba(0,0,0,0.6)",
    "SwanSemColorTextAccent": "#017eb4",
    "SwanSemColorTextHelp": "#3E3CBC",
    "SwanSemColorTextSuccess": "#318643",
    "SwanSemElevationNone": "none",
    "SwanSemElevationSubtle": "0 2px 4px 0 rgba(0,0,0,0.1)",
    "SwanSemElevationStandard": "0 2px 6px 0 rgba(0,0,0,0.1)",
    "SwanSemElevationStrong": "0 2px 8px 0 rgba(0,0,0,0.2)",
    "SwanSemElevationFloating": "0 2px 6px 0 rgba(0,0,0,0.1)",
    "SwanSemElevationOverlay": "0 2px 8px 0 rgba(0,0,0,0.2)",
    "SwanSemElevationScrollHorizontal": "-4px 0 12px 8px #ffffff",
    "SwanSemFocusColorInner": "#ffffff",
    "SwanSemFocusColorOuter": "#017eb4",
    "SwanSemFocusStandard": "0 0 0 2px #ffffff, 0 0 0 4px #017eb4",
    "SwanSemFocusInset": "inset 0 0 0 2px #ffffff, inset 0 0 0 4px #017eb4",
    "SwanSemFocusTight": "0 0 0 2px #017eb4",
    "SwanSemFontSizeX4large": "36px",
    "SwanSemFontSizeX3large": "32px",
    "SwanSemFontSizeX2large": "24px",
    "SwanSemFontSizeXlarge": "20px",
    "SwanSemFontSizeLarge": "20px",
    "SwanSemFontSizeStandard": "16px",
    "SwanSemFontSizeSmall": "14px",
    "SwanSemFontSizeXsmall": "12px",
    "SwanSemMqEqXl": "'only screen and (min-width: 1920px)'",
    "SwanSemMqEqLg": "'only screen and (min-width: 1440px) and (max-width: 1919px)'",
    "SwanSemMqEqMd": "'only screen and (min-width: 1024px) and (max-width: 1439px)'",
    "SwanSemMqEqSm": "'only screen and (min-width: 768px) and (max-width: 1023px)'",
    "SwanSemMqEqXs": "'only screen and (max-width: 767px)'",
    "SwanSemMqGtXl": "'only screen and (min-width: 1920px)'",
    "SwanSemMqGtLg": "'only screen and (min-width: 1920px)'",
    "SwanSemMqGtMd": "'only screen and (min-width: 1440px)'",
    "SwanSemMqGtSm": "'only screen and (min-width: 1024px)'",
    "SwanSemMqGtXs": "'only screen and (min-width: 768px)'",
    "SwanSemMqGteXl": "'only screen and (min-width: 1920px)'",
    "SwanSemMqGteLg": "'only screen and (min-width: 1440px)'",
    "SwanSemMqGteMd": "'only screen and (min-width: 1024px)'",
    "SwanSemMqGteSm": "'only screen and (min-width: 768px)'",
    "SwanSemMqGteXs": "'only screen and (min-width: 0px)'",
    "SwanSemMqLtXl": "'only screen and (max-width: 1919px)'",
    "SwanSemMqLtLg": "'only screen and (max-width: 1439px)'",
    "SwanSemMqLtMd": "'only screen and (max-width: 1023px)'",
    "SwanSemMqLtSm": "'only screen and (max-width: 767px)'",
    "SwanSemMqLtXs": "'only screen and (max-width: 0px)'",
    "SwanSemMqLteXl": "'only screen'",
    "SwanSemMqLteLg": "'only screen and (max-width: 1919px)'",
    "SwanSemMqLteMd": "'only screen and (max-width: 1439px)'",
    "SwanSemMqLteSm": "'only screen and (max-width: 1023px)'",
    "SwanSemMqLteXs": "'only screen and (max-width: 767px)'",
    "SwanSemSpace1": "2px",
    "SwanSemSpace2": "4px",
    "SwanSemSpace3": "8px",
    "SwanSemSpace4": "12px",
    "SwanSemSpace5": "16px",
    "SwanSemSpace6": "24px",
    "SwanSemSpace7": "32px",
    "SwanSemSpace8": "44px",
    "SwanSemSpace9": "56px",
    "SwanSemSpace10": "72px",
    "SwanSemSpace11": "96px",
    "SwanSemSpace12": "128px",
    "SwanSemSpaceNone": "0px",
    "SwanSemZIndexRaised": 1,
    "SwanSemZIndexLinkCovering": 5,
    "SwanSemZIndexOverlay": 10,
    "SwanSemZIndexFloating": 100000,
    "SwanSemZIndexOverTheTop": 1000000,
    "SwanCompAccordionPaddingStandard": "32px calc(24px + 20px) 32px 0",
    "SwanCompAccordionPaddingVertical": "32px",
    "SwanCompAccordionPaddingRightInteger": "17",
    "SwanCompAlertBoxColorBg": "#000000",
    "SwanCompAlertBoxColorTextInverse": "#ffffff",
    "SwanCompAlertBoxLegalColorBg": "#ffffff",
    "SwanCompAlertBoxLegalColorText": "#000000",
    "SwanCompAlertBoxWarningColorText": "#000000",
    "SwanCompAnchorBarListScrollBarColorBorder": "rgba(0,0,0,0.3)",
    "SwanCompAnchorBarSizeMinHeight": "65px",
    "SwanCompAnchorBarListItemBlock": "0px 16px",
    "SwanCompAvatarInnerStroke": "0 0 0 1px #ffffff, inset 0 0 0 1px rgba(0,0,0,0.1)",
    "SwanCompBannerColorBg": "#f8f8f8",
    "SwanCompBannerLeftHandNavigationColorBg": "#ffffff",
    "SwanCompBannerLeftHandNavigationColorText": "rgba(0,0,0,0.9)",
    "SwanCompBannerLeftHandNavigationDividerColorBorder": "#dfdfdf",
    "SwanCompBannerLeftHandNavigationFocus": "0 0 0 2px #ffffff, 0 0 0 4px #017eb4",
    "SwanCompBannerTextContainerColorBg": "rgba(255,255,255,0.9)",
    "SwanCompBannerInner": "16px",
    "SwanCompBannerActionSizeMinHeight": "40px",
    "SwanCompBannerImageContainerSizeMaxHeight": "300px",
    "SwanCompBannerSizeMaxWidth": "1920px",
    "SwanCompBannerSizeMinHeightStandard": "0px",
    "SwanCompBannerSizeMinHeightShort": "0px",
    "SwanCompBannerGridGutterStandard": "8px",
    "SwanCompBannerBoundedContentInnerHorizontal": "calc(16px - 8px)",
    "SwanCompBannerBoundedContentInner": "0px calc(16px - 8px)",
    "SwanCompBannerTextOffset": "0px",
    "SwanCompBoundedContentSizeMaxWidth": "1920px",
    "SwanCompBoundedContentGridGutterStandard": "8px",
    "SwanCompBoundedContentInnerHorizontal": "calc(16px - 8px)",
    "SwanCompBoundedContentInner": "0px calc(16px - 8px)",
    "SwanCompButtonPrimaryColorBg": "#000000",
    "SwanCompButtonPrimaryColorBgHover": "#313131",
    "SwanCompButtonPrimaryColorBgActive": "#5c5c5c",
    "SwanCompButtonPrimaryColorBorder": "#000000",
    "SwanCompButtonPrimaryColorBorderHover": "#000000",
    "SwanCompButtonPrimaryColorBorderActive": "#000000",
    "SwanCompButtonPrimaryColorText": "#ffffff",
    "SwanCompButtonClearSelectionColorBgActive": "#000000",
    "SwanCompButtonClearSelectionSizeHeight": "50px",
    "SwanCompButtonSizeMinHeightStandard": "53px",
    "SwanCompButtonSizeMinHeightMini": "40px",
    "SwanCompButtonbarColorBg": "#dfdfdf",
    "SwanCompButtonbarButtonHeight": "42px",
    "SwanCompCalloutColorBgInverse": "#000000",
    "SwanCompCalloutColorBorderInverse": "rgba(255,255,255,0.3)",
    "SwanCompCalloutColorTextInverse": "#ffffff",
    "SwanCompCalloutFoilColorText": "rgba(0,0,0,0.9)",
    "SwanCompCalloutOverlayColorBg": "#ffffff",
    "SwanCompCalloutOverlayColorText": "rgba(0,0,0,0.9)",
    "SwanCompCarouselButtonColorBg": "rgba(255,255,255,0.7)",
    "SwanCompCarouselButtonColorBgDisabled": "rgba(255,255,255,0.2)",
    "SwanCompCarouselButtonColorBorderDisabled": "rgba(0,0,0,0.1)",
    "SwanCompCarouselButtonOffsetPromoBar": "4px",
    "SwanCompCarouselDotsColorBg": "#707070",
    "SwanCompCarouselDotsColorBgHover": "#5c5c5c",
    "SwanCompCarouselDotsColorBgInset": "#ffffff",
    "SwanCompCarouselDotWidth": "12px",
    "SwanCompCarouselArrowSize": "40px",
    "SwanCompCarouselGridGutterStandard": "8px",
    "SwanCompCarouselGridGutterTight": "2px",
    "SwanCompCarouselBoundedContentInnerHorizontal": "calc(16px - 8px)",
    "SwanCompCarouselBoundedContentInner": "0px calc(16px - 8px)",
    "SwanCompColorSwatchesCrossbarColorBg": "#151515",
    "SwanCompColorSwatchesTooltipColorBg": "#000000",
    "SwanCompColorSwatchesTooltipColorText": "#ffffff",
    "SwanCompColorSwatchesSelectedGutterStandard": "6px",
    "SwanCompColorSwatchesSelectedGutterSuper": "1px",
    "SwanCompColorSwatchesSizeStandard": "16px",
    "SwanCompColorSwatchesSizeSuper": "36px",
    "SwanCompColorSwatchesBorderWidth": "1px",
    "SwanCompCountAlertColorBg": "#d24345",
    "SwanCompCountAlertColorTextAlert": "#ffffff",
    "SwanCompDropdownSizeMinHeightStandard": "50px",
    "SwanCompDropdownSizeMinHeightMini": "40px",
    "SwanCompGridGutterStandard": "8px",
    "SwanCompGridGutterTight": "2px",
    "SwanCompListboxColorBgSelected": "rgba(0,0,0,0.4)",
    "SwanCompListboxSizeMinHeightStandard": "50px",
    "SwanCompListboxSizeMinHeightMini": "40px",
    "SwanCompModalDialogBackdropColorBg": "rgba(0,0,0,0.6)",
    "SwanCompModalDialogPanelFooterElevation": "0 -5px 5px 0 rgba(0,0,0,0.1)",
    "SwanCompModalDialogInnerSpace": "16px",
    "SwanCompModalDialogPanelInnerSpace": "16px",
    "SwanCompModalDialogPanelButtonsBlockMenu": "16px 16px",
    "SwanCompModalDialogPanelSizeWidthCapped": "100%",
    "SwanCompModalDialogPanelSizeMaxWidthMenu": "calc(100vw - 24px)",
    "SwanCompModalDialogCloseButtonSize": "24px",
    "SwanCompModalDialogCloseButtonTop": "16px",
    "SwanCompModalDialogGridGutterStandard": "8px",
    "SwanCompModalDialogInnerHorizontal": "calc(16px - 8px)",
    "SwanCompModalDialogSizeHeight": "100%",
    "SwanCompModalDialogSizeMinHeight": "100%",
    "SwanCompModalDialogSizeMaxHeight": "100%",
    "SwanCompModalDialogSizeWidth": "100%",
    "SwanCompModalDialogSizeMinWidth": "250px",
    "SwanCompModalDialogSizeMaxWidth": "100%",
    "SwanCompModalDialogSizeMaxWidthGrow": "100%",
    "SwanCompModalDialogSizeHeaderMaxWidth": "calc(100% - 20px + 8px)",
    "SwanCompProgressBarEmptyColorBg": "#f8f8f8",
    "SwanCompProgressBarFilledColorBg": "#000000",
    "SwanCompRadioButtonInnerColorBgDisabled": "#9e9e9e",
    "SwanCompRangeEmptyColorBg": "#707070",
    "SwanCompSearchInputClearColorBg": "#dfdfdf",
    "SwanCompSelectionSetColorBorder": "#dfdfdf",
    "SwanCompSelectionSetColorBorderHover": "#5c5c5c",
    "SwanCompSelectionSetColorBorderActive": "#5c5c5c",
    "SwanCompSelectionSetButtonsHeight": "34px",
    "SwanCompSelectionSetTilesHeightStandard": "144px",
    "SwanCompSelectionSetTilesWidthStandard": "164px",
    "SwanCompSelectionSetTilesWidthVertical": "164px",
    "SwanCompSelectionSetTilesImageWidthStandard": "144px",
    "SwanCompSelectionSetTilesImageWidthMini": "60px",
    "SwanCompSelectionSetTilesImageHeightStandard": "144px",
    "SwanCompSelectionSetTilesImageHeightVertical": "88px",
    "SwanCompSpinnerSizeAnimationTiny": "18px",
    "SwanCompSpinnerSizeAnimationMini": "27px",
    "SwanCompSpinnerSizeAnimationStandard": "36px",
    "SwanCompSpinnerSizeAnimationSuper": "54px",
    "SwanCompStandardTileGridGutterStandard": "8px",
    "SwanCompStandardTileGridGutterTight": "2px",
    "SwanCompStandardTileBlock": "0px 0px 32px 0px",
    "SwanCompStandardTileBlockEnd": "32px",
    "SwanCompStandardTileNameBlock": "0px 0px 8px",
    "SwanCompStandardTileNameBlockEnd": "8px",
    "SwanCompStandardTileSizeHeight": "calc(100% - 32px)",
    "SwanCompTextInputSizeMinHeightStandard": "50px",
    "SwanCompTextInputSizeMinHeightMini": "40px",
    "SwanCompThumbnailsHeroContentContainerMaxWidth": "1440px",
    "SwanCompToggleSwitchColorBgSelected": "#000000",
    "SwanCompToggleSwitchColorBgDisabled": "#dfdfdf",
    "SwanCompToggleSwitchHandleColorBg": "#ffffff",
    "SwanCompToggleSwitchTrackColorBg": "#5c5c5c",
    "SwanCompToggleSwitchSizeMiniWidth": "28px",
    "SwanCompToggleSwitchSizeMiniHeight": "16px",
    "SwanCompToggleSwitchSizeStandardWidth": "36px",
    "SwanCompToggleSwitchSizeStandardHeight": "20px",
    "SwanCompToggleSwitchSizeSuperWidth": "56px",
    "SwanCompToggleSwitchSizeSuperHeight": "28px"
};

export { dtcgTokensRaw };
